import React, { useEffect } from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import '../../Styles/ResearchLabs.css';
import AppHeader from '../../Layout/Header';
import FooterComponent from '../../Layout/Footer';
import gsaglBanner from '../../Assets/ResearchLabs/GSAGL/GSAGL-Hero.jpg';
import uopCampus from '../../Assets/ResearchLabs/GSAGL/HostUniversities/GSAGL-UOP.jpg';
import sbbuCampus from '../../Assets/ResearchLabs/GSAGL/HostUniversities/GSAGL-SBBU.jpg';
import uopLogo from '../../Assets/ResearchLabs/GSAGL/HostUniversities/GSAGL-UOP-Logo.jpg';
import sbbuLogo from '../../Assets/ResearchLabs/GSAGL/HostUniversities/GSAGL-SBBU-Logo.jpeg';
import Scope from './GSAGL Components/Scope';
import ResearchDomains from './GSAGL Components/ResearchDomains';
import PrincipalInvestigator from './GSAGL Components/PrincipalInvestigator';
import Impact from './GSAGL Components/Impact';
import SocialFeed from './GSAGL Components/SocialFeed';

const { Title } = Typography;

const universities = [
  { name: 'University of Peshawar', image: uopCampus, logo: uopLogo },
  { name: 'Shaheed Benazir Bhutto University, Sheringal, Dir', image: sbbuCampus, logo: sbbuLogo },
];

const GSAGL = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
  <>
    <AppHeader />
    <main className="individual-lab-page">
    <div
      className="sarl-lab-hero"
      role="img"
      aria-label="GIS and Space Applications in Geosciences Lab"
      style={{ backgroundImage: `url(${gsaglBanner})` }}
    />

    <section className="host-university-section">
      <div className="host-university-inner">
        <Title level={2} className="host-university-title">Host Universities</Title>
        <Divider className="ncgsa-divider" />
        <Row gutter={[72, 40]}>
          {universities.map((university) => (
            <Col xs={24} md={12} key={university.name}>
              <article className="host-university-card">
                <div className="host-university-identity">
                  <img
                    className="university-logo-img"
                    src={university.logo}
                    alt={`${university.name} logo`}
                  />
                  <Title level={5} className="university-name">{university.name}</Title>
                </div>
                <img className="host-university-campus" src={university.image} alt={university.name} />
              </article>
            </Col>
          ))}
        </Row>
      </div>
    </section>

    <Scope />
    <ResearchDomains />
    <Impact />
    <PrincipalInvestigator />
    <SocialFeed />
    </main>
    <FooterComponent />
  </>
  );
};

export default GSAGL;
